import propertyUtils from '@/services/property/property.utils.js';
import moment from 'moment';

export default {
  /* Set form values in documents Model */
  setFormValuesInDocuments(form, document, attributes) {
    let documentChanges = {};
    if (document) {
      documentChanges = {
        ...document,
        AttsList: [],
      };
    }
    form?.forEach((control) => !control.IsDeleted && this.setValueInDocuments(attributes, document, documentChanges, control));

    return documentChanges;
  },

  /* Set values in documents Model */
  setValueInDocuments(attributes, document, documentChanges, { InternalField, FieldDataType, Value }) {
    const attMaster = attributes.find((att) => att.FeatureName === InternalField);

    if (!attMaster || !attMaster?.AttID) {
      if (Value !== null || !document[InternalField]) {
        documentChanges[InternalField] = Value;
      }
    } else {
      const dataTypeMapping = {
        bool: 'BoolValue',
        datetime: 'DateValue',
        decimal: 'DecimalValue',
        int: 'IntegerValue',
        string: 'StringValue',
      };
      const dataType = dataTypeMapping[FieldDataType];
      const attOriginalDoc = document?.AttsList.find((att) => att.FeatureName === InternalField);

      if (Value !== null) {
        const attr = {
          AttrRowId: attOriginalDoc?.AttrRowId,
          AttId: attMaster.AttID,
          FeatureName: InternalField,
          [dataType]: Value,
        };
        documentChanges.AttsList.push(attr);
      } else if (attOriginalDoc?.AttrRowId) {
        documentChanges.AttsList.push(attOriginalDoc);
      }
    }
  },

  exportDocument(doc, title = '') {
    // Create an invisible A element
    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);

    // Set the HREF to a Blob representation of the data to be downloaded
    const blob = propertyUtils.b64toBlob(doc.data.FileData, doc.data.ContentType);
    a.href = window.URL.createObjectURL(new Blob([blob], { type: doc.data.ContentType }));

    // From the response we get the configuration sent to the API, to check what the format is, at that moment in the loop. And apply the correct title for the downloaded document
    const formatDate = moment(new Date()).format('YYYYMMDDHHmm');
    const documentName = `${title}_${formatDate}`;

    // Use download attribute to set set desired file name
    a.setAttribute('download', documentName);

    // Trigger the download by simulating click
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  },
};
